
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

/**
 * Alternative approach to handle missing columns without requiring RPC functions
 */
export const fixDatabaseSchema = async () => {
  try {
    console.log("Verificando se colunas repo_type e repo_name existem...");
    
    // Test if we can access repo_type and repo_name
    const { error: testError } = await supabase
      .from('components')
      .select('repo_type, repo_name')
      .limit(1);
    
    // If columns don't exist, we'll get an error
    if (testError && testError.message?.includes('does not exist')) {
      console.log("Colunas não existem. Alternativa: usando método de fallback...");
      
      // Store in localStorage that we need to handle these columns carefully
      localStorage.setItem('components_missing_repo_columns', 'true');
      
      toast({
        title: "Aviso",
        description: "Para usar todas as funcionalidades, contate o administrador para adicionar colunas repo_type e repo_name à tabela components.",
        duration: 10000,
      });
      
      return false;
    } else {
      // Columns exist, clear the flag
      localStorage.removeItem('components_missing_repo_columns');
      return true;
    }
  } catch (error) {
    console.error("Erro ao verificar estrutura do banco:", error);
    return false;
  }
};

/**
 * Check if components table is missing the repo columns
 */
export const isMissingRepoColumns = () => {
  return localStorage.getItem('components_missing_repo_columns') === 'true';
};
